/**
 * Cartão de convite de conta no modal de resultado ("Salvar este resultado na ficha do paciente").
 *
 * Desligado por padrão: só deve ser promovido depois que o consentimento do PR #39 e a coluna
 * `comunicacao_douto` estiverem no ar. Sem a flag, o modal mantém o botão discreto de salvar na ficha de antes.
 * Para ligar: defina VITE_ACCOUNT_CTA=on nas variáveis de ambiente do projeto Cloudflare Pages e refaça o deploy.
 * Para desligar: remova a variável (ou use qualquer outro valor) e refaça o deploy.
 */
export const accountCtaEnabled = () => import.meta.env.VITE_ACCOUNT_CTA === 'on';

/**
 * Banners do Douto em pontos estratégicos (docs/douto-banners/MAPA.md).
 * Ligada no preview, desligada em produção até o Cadu decidir.
 * Ligar: VITE_DOUTO_BANNERS=on no ambiente de build e refazer o deploy. Desligar: remover a variável e refazer o deploy.
 */
export const doutoBannersEnabled = () => import.meta.env.VITE_DOUTO_BANNERS === 'on';

/** Faixa inferior "Novidades". Ligar: VITE_NOVIDADES_BANNER=on no build; desligar: remover a variável. */
export const novidadesBannerEnabled = () => import.meta.env.VITE_NOVIDADES_BANNER === 'on';

/** Aviso de reavaliação por e-mail. Ligar (VITE_LEMBRETES=on) só depois de: tabela lembretes_reavaliacao no NCB, EMAILIT_API_KEY e LEMBRETES_* no Pages (docs/lembretes-reavaliacao.md). */
export const lembretesEnabled = () => import.meta.env.VITE_LEMBRETES === 'on';
